import mitt from 'mitt';

globalThis.caiEventBus = globalThis.caiEventBus || mitt();

// eventBus.once
if (!Object.prototype.hasOwnProperty.call(globalThis.caiEventBus, 'once')) {
  globalThis.caiEventBus.once = (eventName, listener) => {
    const wrapper = event => {
      globalThis.caiEventBus.off(eventName, wrapper);
      listener(event);
    };
    return globalThis.caiEventBus.on(eventName, wrapper);
  };
}
const eventBus = globalThis.caiEventBus;

// deprecated exported events
const send = (...args) => globalThis.caiEventBus.emit(...args);
const listen = (...args) => globalThis.caiEventBus.on(...args);
const unlisten = (...args) => globalThis.caiEventBus.off(...args);

export { eventBus, listen, send, unlisten };
